import {Component, Input, OnInit} from '@angular/core';

export interface TractorsHectaresPerTractor {
  domainID: number;
  domainName: string;
  hectaresPerTractor: number;
}

@Component({
  selector: 'app-tractors-hectares-per-tractor-widget',
  templateUrl: './tractors-hectares-per-tractor-widget.component.html',
  styleUrls: ['./tractors-hectares-per-tractor-widget.component.scss']
})
export class TractorsHectaresPerTractorWidgetComponent implements OnInit {

  @Input()
  data: TractorsHectaresPerTractor[];

  constructor() {
  }

  ngOnInit(): void {
  }

}
